import React, { useEffect, useState, useContext } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import Header from "../components/header";
import Menu from "../components/menu";
import MainRoute from "../router/mainRoute";
import SideBar from "../components/sideBar";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { mainLayout } from "../global/styles";
import * as apiService from "../../api";
import SessionTimeout from "../components/sessionTimeout";
import DialogSessionTimeout from "../components/dialogSessionTimeout";
import { ConfigurationContext } from "../context/configurationContext";
import { setFeatureFlags, setIsFeatureFlagLoad } from "../redux/features/configuration/configurationSlice";
import OnboardingContainer from "../components/onboarding/onboardingContainer";


const drawerWidth = 250;

// Componente interno que tiene acceso a useLocation
const LayoutContent = () => {
  const { isLoginPage,getAlertaPersonalizada } = useContext(ConfigurationContext);
  const [sessionOpenModal, setSessionOpenModal] = useState(false);
  const handlerCloseSessionModal = () => setSessionOpenModal(false);
  const infoAfiliado = useSelector((state) => state.afiliado.infoAfiliado);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const featureFlags = useSelector((state) => state.configuration.feauteFlags);
  const location = useLocation();

  const dispatch = useDispatch();

  // Detectar si estamos en onboarding
  const isOnboardingPage = location.pathname === "/onboarding";

  // Ocultar layout si es login o onboarding
  const hideLayout = isLoginPage || isOnboardingPage;

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    apiService.utility
      .getFeatureFlags()
      .then((response) => {
        dispatch(setFeatureFlags(response.data.result));
        dispatch(setIsFeatureFlagLoad(true));
      })
      .catch(console.log);

    return () => {};
  }, [isLoginPage, dispatch]);

  useEffect(() => {
    getAlertaPersonalizada()
  },[])

  return (
    <OnboardingContainer>
      <Box sx={{ display: "flex" }}>
        {!hideLayout && (
          <Box>
            <Menu
              handleDrawerToggle={handleDrawerToggle}
              mobileOpen={mobileOpen}
              drawerWidth={drawerWidth}
              regimen={infoAfiliado.regimen}
            />
          </Box>
        )}
        <Box component="main" sx={!hideLayout ? { ...mainLayout } : null}>
          {!hideLayout ? (
            <Header handleDrawerToggle={handleDrawerToggle} />
          ) : null}

          <Box
            sx={{
              paddingRight: { xs: 2, md: 1 },
              paddingLeft: { xs: 1, md: 0 },
            }}
          >
            {MainRoute}
          </Box>
        </Box>

        {!hideLayout ? featureFlags.verRedesSociales && <SideBar /> : null}
      </Box>
      <SessionTimeout isOpen={sessionOpenModal} setOpen={setSessionOpenModal} />
      <DialogSessionTimeout
        open={sessionOpenModal}
        handlerCloseModal={handlerCloseSessionModal}
      />
    </OnboardingContainer>
  );
};

const Layout = () => {
  return (
    <Router>
      <LayoutContent />
    </Router>
  );
};

export default Layout;
